import LazyLoad from "vanilla-lazyload";

export default class Lazyload {
	constructor() {
		const lazyLoadInstance = new LazyLoad({
            elements_selector: '[data-lazy]',
            thresholds: "150% 0px",
            unobserve_entered: true
        });
	}
}